import {
  Directive,
  Input,
  Host,
  OnInit,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { PgCalendarComponent } from './pg-calendar.component';

import { Observable } from 'rxjs';
import { PgInputDirective } from '../pg-field/pg-input/pg-input.directive';

@Directive({
  selector: '[pgCalendarInput], [gritCalendarInput]',
})
export class PgCalendarInputDirective implements OnInit {
  @Input()
  pgCalendarInput: PgCalendarComponent;

  @Input()
  closeOnBackdropClick = false;

  focusedToOpen = false;

  constructor(
    @Host() public input: PgInputDirective,
    private _cdRef: ChangeDetectorRef
  ) {
    (<Observable<void>>input.stateChanges).subscribe(() => {
      if (!this.focusedToOpen && input.isFocused) {
        this.focusedToOpen = true;
        this.pgCalendarInput.show();
        input.blur();
        input.ngControl.reset(input.value);
      }
    });
  }

  ngOnInit() {
    this.pgCalendarInput.selectedDatesChange.subscribe(data => {
      if (data) {
        this.input.value = data;
        this.pgCalendarInput.hide();
        this.focusedToOpen = false;
        this._cdRef.detectChanges();
      }
    });

    if (this.closeOnBackdropClick) {
      this.pgCalendarInput.backdropClicked.subscribe(() => {
        this.pgCalendarInput.hide();
        this.focusedToOpen = false;
      });
    }
  }

  @HostListener('window:keydown', ['$event'])
  onWindowKeydown(event: KeyboardEvent) {
    if (event.keyCode === 27) {
      this.pgCalendarInput.hide();
      this.focusedToOpen = false;
    }
  }
}
